'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var debug = require('debug');

var log = Object.assign(debug('libp2p:peer-store:proto-book'), {
  error: debug('libp2p:peer-store:proto-book:err')
});

var errcode = require('err-code');

var _require = require('uint8arrays/equals'),
    uint8ArrayEquals = _require.equals;

var PeerId = require('peer-id');

var Book = require('./book');

var _require2 = require('../errors'),
    ERR_INVALID_PARAMETERS = _require2.codes.ERR_INVALID_PARAMETERS;
/**
 * @typedef {import('./')} PeerStore
 */

/**
 * @extends {Book}
 *
 * @fires MetadataBook#change:metadata
 */


var MetadataBook = /*#__PURE__*/function (_Book) {
  _inherits(MetadataBook, _Book);

  var _super = _createSuper(MetadataBook);

  /**
   * The MetadataBook is responsible for keeping the known supported
   * protocols of a peer.
   *
   * @class
   * @param {PeerStore} peerStore
   */
  function MetadataBook(peerStore) {
    var _this;

    _classCallCheck(this, MetadataBook);

    /**
     * PeerStore Event emitter, used by the MetadataBook to emit:
     * "change:metadata" - emitted when the known metadata of a peer change.
     */
    _this = _super.call(this, {
      peerStore: peerStore,
      eventName: 'change:metadata',
      eventProperty: 'metadata'
    });
    /**
     * Map known peers to their known protocols.
     *
     * @type {Map<string, Map<string, Uint8Array>>}
     */

    _this.data = new Map();
    return _this;
  }
  /**
   * Set metadata key and value of a provided peer.
   *
   * @override
   * @param {PeerId} peerId
   * @param {string} key - metadata key
   * @param {Uint8Array} value - metadata value
   * @returns {MetadataBook}
   */
  // @ts-ignore override with more then the parameters expected in Book


  _createClass(MetadataBook, [{
    key: "set",
    value: function set(peerId, key, value) {
      if (!PeerId.isPeerId(peerId)) {
        log.error('peerId must be an instance of peer-id to store data');
        throw errcode(new Error('peerId must be an instance of peer-id'), ERR_INVALID_PARAMETERS);
      }

      if (typeof key !== 'string' || !(value instanceof Uint8Array)) {
        log.error('valid key and value must be provided to store data');
        throw errcode(new Error('valid key and value must be provided'), ERR_INVALID_PARAMETERS);
      }

      this._setValue(peerId, key, value);

      return this;
    }
    /**
     * Set data into the datastructure
     *
     * @override
     * @param {PeerId} peerId
     * @param {string} key
     * @param {Uint8Array} value
     */

  }, {
    key: "_setValue",
    value: function _setValue(peerId, key, value) {
      var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
          _ref$emit = _ref.emit,
          emit = _ref$emit === void 0 ? true : _ref$emit;

      var id = peerId.toB58String();
      var rec = this.data.get(id) || new Map();
      var recMap = rec.get(key); // Already exists and is equal

      if (recMap && uint8ArrayEquals(value, recMap)) {
        log("the metadata provided to store is equal to the already stored for ".concat(id, " on ").concat(key));
        return;
      }

      rec.set(key, value);
      this.data.set(id, rec);
      emit && this._emit(peerId, key);
    }
    /**
     * Get the known data of a provided peer.
     *
     * @param {PeerId} peerId
     * @returns {Map<string, Uint8Array>|undefined}
     */

  }, {
    key: "get",
    value: function get(peerId) {
      if (!PeerId.isPeerId(peerId)) {
        throw errcode(new Error('peerId must be an instance of peer-id'), ERR_INVALID_PARAMETERS);
      }

      return this.data.get(peerId.toB58String());
    }
    /**
     * Get specific metadata value, if it exists
     *
     * @param {PeerId} peerId
     * @param {string} key
     * @returns {Uint8Array | undefined}
     */

  }, {
    key: "getValue",
    value: function getValue(peerId, key) {
      if (!PeerId.isPeerId(peerId)) {
        throw errcode(new Error('peerId must be an instance of peer-id'), ERR_INVALID_PARAMETERS);
      }

      var rec = this.data.get(peerId.toB58String());
      return rec && rec.get(key);
    }
    /**
     * Deletes the provided peer from the book.
     *
     * @param {PeerId} peerId
     * @returns {boolean}
     */

  }, {
    key: "delete",
    value: function _delete(peerId) {
      if (!PeerId.isPeerId(peerId)) {
        throw errcode(new Error('peerId must be an instance of peer-id'), ERR_INVALID_PARAMETERS);
      }

      if (!this.data.delete(peerId.toB58String())) {
        return false;
      }

      this._emit(peerId);

      return true;
    }
    /**
     * Deletes the provided peer metadata key from the book.
     *
     * @param {PeerId} peerId
     * @param {string} key
     * @returns {boolean}
     */

  }, {
    key: "deleteValue",
    value: function deleteValue(peerId, key) {
      if (!PeerId.isPeerId(peerId)) {
        throw errcode(new Error('peerId must be an instance of peer-id'), ERR_INVALID_PARAMETERS);
      }

      var rec = this.data.get(peerId.toB58String());

      if (!rec || !rec.delete(key)) {
        return false;
      }

      this._emit(peerId, key);

      return true;
    }
  }]);

  return MetadataBook;
}(Book);

module.exports = MetadataBook;